import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { useCallback, useEffect, useState } from 'react';
import Modal from 'ud-ui/components/modal';
import { deleteTemplate } from 'modules/template-editor/store/templates/actions';
import { resetPressedState } from 'modules/template-editor/store/templates/templates';
import useTemplates from 'modules/template-editor/ui/hooks/use-templates';
import { isDuplicateRequest } from 'shared/errors';
import { useToastApiError } from 'shared/hooks/use-toast-api-error';
import { useAppDispatch } from 'store/hooks';

function useDeleteModal() {
  const { t } = useLingui();
  const dispatch = useAppDispatch();
  const toastApiError = useToastApiError();
  const { activeTemplate, isFinished, currentProcess } = useTemplates();

  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  // Промис — окну подтверждения: его кнопки заперты до ответа. Закрывает окно эффект ниже по `isFinished`.
  const onSubmit = useCallback(async () => {
    if (!activeTemplate) return;
    const arg = { id: activeTemplate.id };
    try {
      await dispatch(deleteTemplate(arg)).unwrap();
    } catch (error) {
      // Код 15 — повтор: первый запрос шаблон уже удалил. Стор приводится к тому, что дал бы успех, —
      // шаблон уходит из списка, а эффект ниже закрывает окно (раньше оно висело над удалённым).
      if (isDuplicateRequest(error)) {
        dispatch(deleteTemplate.fulfilled(arg, '', arg));
        return;
      }
      toastApiError(error, msg`Не удалось удалить шаблон`);
    }
  }, [activeTemplate, dispatch, toastApiError]);

  useEffect(() => {
    if (!isFinished) {
      return;
    }
    if (currentProcess !== 'delete template') {
      return;
    }
    close();
    dispatch(resetPressedState());
  }, [isFinished, close, dispatch, currentProcess]);

  const entityName = activeTemplate?.name;

  return {
    modal: (
      <Modal.Confirm
        show={isOpen}
        title={entityName ? t`Удалить шаблон «${entityName}»?` : t`Удалить шаблон?`}
        description={t`Это действие необратимо.`}
        onConfirm={onSubmit}
        onCancel={close}
      />
    ),
    close,
    open,
  };
}

export default useDeleteModal;
